<template lang="pug">
.phone-number-container(ref="phoneNumber")
	slot(
		v-bind:countryCode="countryCode"
		v-bind:areaCode="areaCode"
		v-bind:phoneNumber="phoneNumber"
		v-bind:countryCodeOptions="countryCodes"
		v-bind:areaCodeOptions="areaCodeOptions"
		v-bind:onKeyDown="onKeyDown"
		v-bind:onBlur="onBlur"
		v-bind:onInput="onInput"
	)
</template>

<script>
	import {inputFocusHandlerMixin} from '../DNFORM-mixins/DNFORM-input-focus-handler-mixin';
	import {EVENTS, KEYS} from '../DNFORM-utils/DNFORM-constants';

	const INPUT_REF = 'phoneNumber';

	export default {
		name: 'PhoneNumber',
		mixins: [inputFocusHandlerMixin],
		props: {
			value: {
				type: Object,
				required: true
			},
			modelName: {
				type: String,
				required: true
			},
			fixedCountryCode: {
				type: String,
				required: false,
				default: ''
			},
			countryCodes: {
				type: Array,
				required: false,
				default: undefined
			},
			areaCodes: {
				type: Object,
				required: false,
				default: undefined
			}
		},
		data() {
			return {
				countryCode: this.getCountryCode(),
				areaCode: '',
				phoneNumber: '',
				touchedFields: {
					countryCode: false,
					areaCode: false,
					phoneNumber: false
				},
				areaCodeOptions: []
			};
		},
		computed: {
			hasSelectOptions() {
				return !!(this.countryCodes && this.countryCodes.length && this.areaCodes && Object.keys(this.areaCodes).length);
			}
		},
		watch: {
			value: {
				immediate: true,
				handler(newValue) {
					if (newValue.countryCode && newValue.areaCode && newValue.phoneNumber) {
						this.countryCode = this.getCountryCode(newValue.countryCode);
						this.areaCode = newValue.areaCode;
						this.phoneNumber = newValue.phoneNumber;
					}
				}
			},
			countryCode: {
				immediate: true,
				handler(newCountryCode) {
					if (this.hasSelectOptions) {
						this.getAreaCodeOptionsForCountryCode(newCountryCode);
						this.selectFirstAreaCodeOption();
					}
					this.emitPhoneNumberObject();
				}
			},
			areaCode() {
				this.emitPhoneNumberObject();
			},
			phoneNumber() {
				this.emitPhoneNumberObject();
			}
		},
		mounted() {
			if (this.countryCode || this.fixedCountryCode) {
				this.touchedFields.countryCode = true;
			}

			if (this.areaCode) {
				this.touchedFields.areaCode = true;
			}

			if (this.phoneNumber) {
				this.touchedFields.phoneNumber = true;
			}
		},
		methods: {
			getCountryCode(value) {
				return value || this.fixedCountryCode || (this.hasSelectOptions ? this.countryCodes[0] : '');
			},
			getAreaCodeOptionsForCountryCode(newCountryCode) {
				this.areaCodeOptions = this.areaCodes[newCountryCode] || [];
			},
			selectFirstAreaCodeOption() {
				this.areaCode = this.areaCodeOptions.length ? this.areaCodeOptions[0] : '';
			},
			onKeyDown(event) {
				if (event.key && event.key.length == 1 && !event.key.match(/[0-9]/)) {
					event.preventDefault();
				}

				if (event.key === KEYS.BACKSPACE) {
					this.setFocusOnPrevInput(event.target, INPUT_REF, this.shouldSetFocusOnPrevInput);
				}
			},
			onBlur(event, id) {
				// The id param comes from the select component's select event
				this.touchedFields[id || event.target && event.target.name] = true;
				const allFieldsTouched = Object.values(this.touchedFields).every((field) => !!field);

				if (allFieldsTouched) {
					this.$emit(EVENTS.BLUR_TO_VALIDATE, this.modelName);
				}
			},
			onInput(event, field) {
				const isInputTypeSelect = event && typeof event === 'string';
				// If true then the event parameter is equal to the selected value
				this[field] = isInputTypeSelect ? event : event.target && event.target.value;

				if (!isInputTypeSelect && event) {
					this.setFocusOnNextInput(event.target, INPUT_REF, this.shouldSetFocusOnNextInput);
				}
			},
			emitPhoneNumberObject() {
				let phoneNumber = {
					countryCode: this.countryCode,
					areaCode: this.areaCode,
					phoneNumber: this.phoneNumber
				};

				const staticCountryCode = !!(this.fixedCountryCode || this.hasSelectOptions);
				const staticAreaCode = !!this.areaCodes;
				// empty model when no phoneNumber set and there are static area and country codes
				if (!this.phoneNumber && staticAreaCode && staticCountryCode ||
					!this.phoneNumber && !this.areaCode && staticCountryCode) {
					phoneNumber = {
						countryCode: '',
						areaCode: '',
						phoneNumber: ''
					};
				}

				this.$emit(EVENTS.INPUT, phoneNumber);
				this.$emit(EVENTS.INPUT_TO_VALIDATE, this.modelName);
			},
			shouldSetFocusOnPrevInput(targetInput) {
				const {value, dataset} = targetInput;
				return !value.length && dataset.autoTabIndex;
			},
			shouldSetFocusOnNextInput(targetInput) {
				const {maxLength, value, dataset} = targetInput;
				return maxLength === value.length && dataset.autoTabIndex;
			}
		}
	};
</script>



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-phone-number/DNFORM-phone-number.vue